import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectCheckmarks({data, handleChange}) {
  const [dataSelect, setDataSelect] = React.useState([]);

  const handleChangeSelect = event => {
    const {
      target: {value},
    } = event;

    const selectedIds =
      typeof value === 'string' && value ? value.split(',') : value || [];
    setDataSelect(selectedIds);
  };

  React.useEffect(() => {
    const dataSend = dataSelect.length === 0 ? '' : dataSelect.join(',');
    handleChange(dataSend, data.id);
  }, [dataSelect]);

  return (
    <FormControl sx={{width: '100%'}}>
      <InputLabel
        id="demo-multiple-checkbox-label"
        style={{backgroundColor: '#fff', padding: '0px 5px'}}>
        {data?.item}
      </InputLabel>
      <Select
        multiple
        value={dataSelect}
        onChange={handleChangeSelect}
        input={<OutlinedInput label={data?.item} />}
        renderValue={selected => {
          const selectedOptions = data?.opciones
            ?.filter(opt => selected.includes(opt.id))
            ?.map(opt => opt.opcion);
          return selectedOptions.join(', ');
        }}
        MenuProps={MenuProps}>
        {data?.opciones?.map(opt => (
          <MenuItem key={opt.id} value={opt.id}>
            <Checkbox checked={dataSelect.includes(opt.id)} />
            <ListItemText primary={opt.opcion} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
